// this file is automatically generated by git.version.ts script
export const versions = {
  version: '1.0.37',
  revision: 'e9070af',
  branch: 'develop',
};
